import React, { useState } from "react";

const TruncateText = ({ maxLength, text }) => {
  const [readMore, setReadMore] = useState(false);

  return (
    <>
      {text.length > maxLength ? (
        readMore ? (
          <p>
            {text}
            <span
              className="read-more-class"
              onClick={() => setReadMore(false)}
            >
              read less
            </span>
          </p>
        ) : (
          <p>
            {text.slice(0, maxLength)}...
            <span
              className="read-more-class"
              onClick={() => setReadMore(true)}
            >
              read more
            </span>
          </p>
        )
      ) : (
        <p>{text}</p>
      )}
    </>
  );
};

export default TruncateText;
